module.exports = __webpack_public_path__ + "img/hm_block02_sc.218a0bb6.jpg";